import { render, staticRenderFns } from "./CandidateStatusHeader.vue?vue&type=template&id=4f674942&scoped=true&"
import script from "./CandidateStatusHeader.vue?vue&type=script&lang=js&"
export * from "./CandidateStatusHeader.vue?vue&type=script&lang=js&"
import style0 from "./CandidateStatusHeader.vue?vue&type=style&index=0&id=4f674942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f674942",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f674942')) {
      api.createRecord('4f674942', component.options)
    } else {
      api.reload('4f674942', component.options)
    }
    module.hot.accept("./CandidateStatusHeader.vue?vue&type=template&id=4f674942&scoped=true&", function () {
      api.rerender('4f674942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CandidateStatusHeader.vue"
export default component.exports